import React, { useState } from "react";
import { useAppDispatch } from "../../../app/features/store/store";
import { toast } from "react-toastify";
import { AddRoleRequest } from "../../../app/models/requestModels/roleRequest";
import { updateUserTokenToInvalid } from "../../../app/features/login/loginSlice";
import getAxiosError from "../../../app/api/axiosError";
import SubmitModal from "../../../components/common/modalPopup/SubmitModal";
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import { addRole } from "../../../app/features/role/roleSlice";

interface AddRoleModalProps {
  closeAddRoleModal: CallableFunction;
  onCompleted: CallableFunction;
}

function AddRoleModel(name: string, deleted: string): AddRoleRequest {
  return {
    name: name,
    deleted: deleted,
  };
}

const AddRoleModal = ({
  closeAddRoleModal,
  onCompleted,
}: AddRoleModalProps) => {
  const dispatch = useAppDispatch();

  // ***** States *****
  const [name, setName] = useState("");
  const [deleted, setDeleted] = useState("false");

  // ***** Handlers *****
  const handleSubmit = async () => {
    try {
      if (name.length === 0) {
        toast.error("Role name is required");
        return false;
      }
      const model = AddRoleModel(name, deleted);
      const response = await dispatch(addRole(model)).unwrap();
      if (response.isSuccess) {
        toast.success(response.message!, {
          toastId: "addRoleSuccess",
        });
        onCompleted();
      } else {
        toast.error(response.message!, {
          toastId: "addRoleError",
        });
      }
    } catch (error) {
      const appError = getAxiosError(error);
      toast.error(appError.errorMessage, {
        toastId: "addRoleException",
      });
    }
    return true;
  };

  return (
    <>
      <SubmitModal
        title="Add Role"
        asyncOperation={handleSubmit}
        closeSubmitModal={closeAddRoleModal}
        allowSubmit={true}
        size="sm"
        isLoading={false}
        submitButtonName="Save"
        closeModalAfterSubmit={true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                margin="normal"
                id="name"
                label="Name"
                name="name"
                size="small"
                fullWidth
                required
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </Grid>
          </Grid>
          <Grid container rowSpacing={2} columnSpacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                select
                margin="normal"
                id="deleted"
                label="Deleted"
                name="deleted"
                size="small"
                fullWidth
                value={deleted}
                onChange={(event) => setDeleted(event.target.value)}
              >
                <MenuItem key="true" value="true">
                  True
                </MenuItem>
                <MenuItem key="false" value="false">
                  False
                </MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </SubmitModal>
    </>
  );
};

export default AddRoleModal;
